import React from "react";
import styled from "styled-components";

import Case from "./case";

const Desktop = ({ children, phonebg }) => {
  return (
    <Holder>
      <Case phonebg={phonebg}>{children}</Case>
    </Holder>
  );
};

const Holder = styled.div`
  display: grid;
  height: 100vh;
  width: 100vw;
  align-content: center;
  justify-content: center;
  background-color: gray;
`;

export default Desktop;
